module.exports = __webpack_public_path__ + "img/104.c674f495.png";